var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34395 0.0839844C6.99984 0.0844902 6.66222 0.177698 6.36659 0.353809C6.07097 0.52992 5.82824 0.782427 5.66395 1.08478L1.34395 9.02878C1.24924 9.20426 1.19975 9.40058 1.19995 9.59998V22.8C1.19995 23.1182 1.32638 23.4235 1.55142 23.6485C1.77647 23.8736 2.08169 24 2.39995 24H16.908C17.6975 24 18.4652 23.7403 19.0927 23.2611C19.7203 22.7819 20.1728 22.1097 20.3808 21.348L22.6728 12.948C22.8185 12.4139 22.8392 11.8534 22.7331 11.3101C22.627 10.7667 22.397 10.2552 22.061 9.81518C21.7251 9.37519 21.2921 9.0186 20.7959 8.77315C20.2997 8.5277 19.7536 8.40001 19.2 8.39998H11.4V4.13998C11.4 3.06427 10.9726 2.03261 10.212 1.27196C9.45133 0.511312 8.41967 0.0839844 7.34395 0.0839844Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.ff8248b63911e084c951e98affefb248.svg";
export { ForwardRef as ReactComponent };